export default function getBaseUrl(): string {
  // eslint-disable-next-line no-template-curly-in-string
  const url = '${NIMBUS_REST_API_URL}';

  if (url.includes('.')) {
    return url;
  }
  return `http://${window.location.hostname}:8080`;
}
